import React from 'react';
import authRoles from '../../auth/authRoles';

const Integrations = React.lazy(() => import('./Integrations'));
const Integration = React.lazy(() => import('./integration/Integration'));
const CreateIntegration = React.lazy(() => import('./create/CreateIntegration'));

const IntegrationsAppConfig = {
	settings: {
		layout: {}
	},
	auth: authRoles.ameroAdmin,
	routes: [
		{
			path: '/integrations',
			element: <Integrations />
		},
		{
			path: '/integrations/:integrationId',
			element: <Integration />
		},
		{
			path: '/integrations/createIntegration',
			element: <CreateIntegration />
		}
	]
};

export default IntegrationsAppConfig;
